import { v4 } from 'uuid';

import { keycloak } from '../auth';
import { Api } from './api.generated';
import { fetchWrapper, withErrorHandler } from './errorHandler';
import type { AppAuditDto, ErrorResponse, FullRequestParams, HttpResponse } from './api.generated';

export * from './api.generated';

export type CmApi = Omit<Api<unknown>, 'request' | 'baseUrl' | 'setSecurityData'>;

declare const REACT_APP_ENV: { [index: string]: string | null | undefined };
export const reactBaseUrl = REACT_APP_ENV.REACT_APP_API_BASE_URL ?? import.meta.env.REACT_APP_API_BASE_URL;

if (!reactBaseUrl) {
  throw new Error(
    'не задана переменная окружения REACT_APP_API_BASE_URL, для rss-dev - http://rss-client.dev.k8s.ksnm.adp.local/rss',
  );
}

const {
  request,
  baseUrl: _,
  setSecurityData: _s,
  ...api
} = new Api({
  baseUrl: reactBaseUrl,
  securityWorker: () => ({
    headers: {
      Authorization: `Bearer ${keycloak.token}`,
    },
  }),
});

export const customRequest = (params: FullRequestParams) =>
  fetchWrapper(() =>
    request({
      ...params,
      secure: params.secure ?? true,
      headers: params.headers ?? {
        'Content-Type': 'application/json',
      },
    }),
  )();

export const fetchWithAudit = async <T>(
  fetch: Promise<HttpResponse<T, ErrorResponse>>,
  audit: AppAuditDto,
  isSuccessfulCode?: number,
): Promise<HttpResponse<T, ErrorResponse>> => {
  const response = await fetch;

  if (isSuccessfulCode) {
    if (response.status === isSuccessfulCode) {
      api.audit.createAuditData({ ...audit, id: v4() });
    }
  } else {
    api.audit.createAuditData({ ...audit, id: v4() });
  }

  return response;
};

export const cmApi = withErrorHandler(api);
